const controllers = {
  home: require('./views/home'),
  ammenities: require('./views/ammenities'),
  gallery: require('./views/gallery'),
  contact: require('./views/contact'),
  sales: require('./views/sales'),
  rents: require('./views/rents'),
  quote: require('./views/quote'),
  quote_sales: require('./views/quote-sales'),
  locations: require('./views/locations'),
  blog: require('./views/blog'),
}

export default controllers
